import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "../App.css";
import { Tab } from "@headlessui/react";
import { motion } from "framer-motion";
import f1 from "../img/f1.jpg";
import {
  UserIcon,
  ClockIcon,
  UsersIcon,
  WindowIcon,
} from "@heroicons/react/20/solid";
import { HiArrowUpRight } from "react-icons/hi2";
import Footer from "../component/Footer";
import CTA from "../component/CTA";
import Modal from "../component/Modal";
import Marquee from "react-fast-marquee";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GoPrimitiveDot } from "react-icons/go";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Home() {
  const [review, setReview] = useState([]);
  const [blog, setBlog] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [type, setType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (review.length === 0) {
      axios
        .get(`${process.env.REACT_APP_SERVER_ROUTE}/review`)
        .then((res) => {
          setReview(res.data);
          console.log(review);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (blog.length === 0) {
      axios
        .get(`${process.env.REACT_APP_SERVER_ROUTE}/blog`)
        .then((res) => {
          setBlog(res.data);
          console.log(blog);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  });

  let [courses] = useState({
    IGCSE: [
      {
        id: 1,
        name: "IGCSE",
        description:
          "IGCSE (International General Certificate of Secondary Educational) เป็นหลักสูตรการสอบเทียบวุฒิมัธยมศึกษาตอนปลาย จากประเทศอังกฤษ ซึ่งหลักสูตรเป็นที่ยอมรับในระดับนานาชาติ ใช้ระยะเวลาเรียน 2 ปี โดยเป็นหลักสูตรของนักเรียนอายุ 14 – 16 ปี ที่ต้องสอบให้ผ่านอย่างน้อย 5 วิชา ในช่วง year 10 และ 11 ซึ่งกระทรวงศึกษาฯ ของไทยจะรับรองวุฒิให้เทียบเท่าวุฒิ ม.6 ก็ต่อเมื่อนักเรียนสอบ AS หรือ A-LEVEL เพิ่มอีก 3 วิชา จึงจะสามารถนำวุฒิไปสมัครเรียนต่อในระดับมหาวิทยาลัยได้",

        imgUrl: "./img/igcse.jpg",
        href: "https://en.wikipedia.org/wiki/International_General_Certificate_of_Secondary_Education",
        level: ["Year 7 - 8", "Year 9 - 11"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนเข้า IGCSE", "IGCSE "],
        subjects: [
          ["Basic Math", "Basic Science"],
          [
            "Math",
            "Eng-SL",
            "Biology",
            "Physics",
            "Economic",
            "Fur-Math",
            "Chemistry",
          ],
        ],
      },
    ],
    "A-LEVEL": [
      {
        id: 1,
        name: "A-LEVEL",
        description:
          "ระบบการศึกษาของอังกฤษ เพื่อเตรียมตัวสู่การเรียนระดับมหาวิทยาลัย ประกาศของกระทรวงศึกษาธิการเมื่อปี 2565 ผลสอบ A-Level 3 วิชา (ไม่ต่ำกว่า E) เมื่อรวมกับผลสอบ IGCSE 5 วิชา (ไม่ต่ำกว่า C) สามารถเทียบวุฒิเท่ากับ ม.6 ได้ A-Level มีวัตถุประสงค์เพื่อเตรียมความพร้อมและความรู้ที่จำเป็นสำหรับการศึกษาต่อในระดับมหาวิทยาลัย โดยใช้ระยะเวลาในการเรียน 2 ปี โดย A-Level มีเนื้อหาที่หลากหลายเพื่อให้นักเรียนเลือกวิชาที่ถนัดเพื่อเตรียมความพร้อมสำหรับการเรียนในมหาวิทยาลัยต่อไป",
        subjects: [["Chemistry", "Math", "Economic", "Biology", "Physics"]],

        imgUrl: "./img/blog.jpg",
        href: "https://en.wikipedia.org/wiki/A-Level",
        level: ["Year 12 - 13"],
        course: ["A-Level"],
      },
    ],
    IB: [
      {
        id: 1,
        name: "IB",
        description:
          "IB (International Baccalaureate) คือ หลักสูตรที่ประยุกต์จากระบบการศึกษาต่างๆทั่วโลก เพื่อที่จะเอาคะแนนไปยื่นเข้าสอบหรือสมัครเรียนต่อในมหาวิทยาลัยต่างๆทั่วโลก ใช้แพร่หลายทั่วโลกมากกว่า 125 ประเทศ วัตถุประสงค์ของการก่อตั้งหลักสูตรนี้ก็เพื่อให้มีระบบการศึกษาในรูปแบบใหม่ที่เป็นที่ยอมรับจากมหาวิทยาลัยทั่วโลก โดยใช้เวลาเรียนทั้งหมด 2 ปี (2 ปีสุดท้ายก่อนเรียนจบ High school) โดยหลักสูตรนี้จะสอนให้นักเรียนในระบบฝึกคิดเชิงวิพากษ์ ควบคู่ไปกับการศึกษาวัฒนธรรมอื่นๆ ผ่านการเรียนภาษานั้นๆ นักเรียนที่ผ่านการเรียนการสอนระบบ IB จึงมีทักษะที่จะเป็นผู้ริเริ่มที่คำนึงถึงความแตกต่างของวัฒนธรรมในอนาคตได้อย่างดี",
        subjects: [["Chemistry", "Math", "Biology", "Physics"]],

        imgUrl: "./img/blog.jpg",
        href: "https://th.wikipedia.org/wiki/International_Baccalaureate",
        level: ["Year 12 - 13"],
        course: ["IB"],
      },
    ],
    AP: [
      {
        id: 1,
        name: "AP",
        description:
          "Advanced Placement หรือ การสอบ AP คือ ประเภทของการทดสอบเพื่อเตรียมความพร้อมในการเข้าเรียนระดับปริญญาตรี เป็นหลักสูตรของทางสหรัฐฯ ดำเนินการโดย College Board หน่วยงานเดียวกับการออกข้อสอบ SAT แนวทางจะถูกใช้สำหรับคนที่เรียนโครงการหลักสูตรล่วงหน้าในระดับมัธยมปลาย ส่วนมากหลักสูตร AP มักนิยมใช้กับกลุ่มโรงเรียนนานาชาติ โรงเรียนอินเตอร์ในประเทศไทย",
        subjects: [
          ["Basic Math", "Basic Science"],
          ["Chemistry", "Math", "Biology", "Physics"],
        ],

        imgUrl: "./img/blog.jpg",
        href: "https://en.wikipedia.org/wiki/Advanced_Placement",
        level: ["Grade 6 - 8", "Grade 9 - 12"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนสอบ AP", "AP "],
      },
    ],
    "SAT I": [
      {
        id: 1,
        name: "SAT I",
        description:
          "SAT คือ ข้อสอบที่ใช้ทดสอบการใช้เหตุผลในวิชาคณิตศาสตร์และภาษาอังกฤษของนักเรียนชั้นมัธยมศึกษาตอนปลาย เพื่อใช้ในการเข้าศึกษาต่อยังสถาบันอุดมศึกษา ในระบบการศึกษาของสหรัฐอเมริกา และในปัจจุบันมีมหาวิทยาลัยอินเตอร์หลาย ๆ แห่ง ได้นำคะแนนสอบมา SAT มาใช้เป็นเกณฑ์อีกด้วย",
        subjects: [
          ["Basic Math", "Basic English"],
          ["Math", "English"],
        ],

        imgUrl: "./img/blog.jpg",
        href: "https://th.wikipedia.org/wiki/%E0%B9%80%E0%B8%AD%E0%B8%AA%E0%B9%80%E0%B8%AD%E0%B8%97%E0%B8%B5",
        level: ["Grade 6 - 8", "Grade 9 - 12"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนสอบ SAT I", "SAT I "],
      },
    ],
    "SAT II": [
      {
        id: 1,
        name: "SAT II",
        description:
          "SAT II คือข้อสอบวัดระดับสำหรับนักเรียนมัธยมศึกษาตอนปลายเพื่อใช้ในการสมัครเข้ามหาวิทยาลัยชั้นนำทั่วโลก โดยข้อสอบแบ่งออกเป็น 5 สาขา ได้แก่ คณิตศาสตร์ ภาษาอังกฤษ ประวัติศาสตร์ ภาษาศาสตร์ และ วิทยาศาสตร์ ซึ่งมีจำนวนทั้งหมดกว่า 20 วิชา ทั้งนี้ คะแนนแต่ละวิชาของ SAT II อยู่ระหว่าง 200 ถึง 800 คะแนน",
        subjects: [["Basic Math"], ["Math"]],

        imgUrl: "./img/blog.jpg",
        href: "https://en.wikipedia.org/wiki/SAT_Subject_Tests",
        level: ["Grade 6 - 8", "Grade 9 - 12"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนสอบ SAT II", "SAT II"],
      },
    ],
    หลักสูตรไทย: [
      {
        id: 1,
        name: "หลักสูตรไทย",
        description: "",
        subjects: [
          ["Math", "Science", "English"],
          ["Math", "Science", "English"],
          ["Math", "Science", "English"],
          ["Math", "Physics", "Chemistry", "Biology", "English"],
          ["TPAT1 ความถนัดทางด้านคณิตศาสตร์"],
          ["TPAT3 ความถนัดทางด้านวิศวกรรมศาสตร์"],
          ["Math", "Physics", "Chemistry", "Biology", "English"],
        ],

        imgUrl: "./img/thai_curriculum.png",
        href: "https://en.wikipedia.org/wiki/International_General_Certificate_of_Secondary_Education",
        level: ["ป. 6", "ม. 1 - 3", "ม. 3", "ม. 4 - 6", "ม. 6", "", ""],
        course: [
          "สอบเข้า ม. 1",
          "ปูพื้นฐานและเพิ่มเกรดก่อนเพื่อสอบเข้า ม. 4 รร.เตรียมอุดม, มหิดลวิทย์ ฯลฯ",
          "ตะลุยโจทย์สอบเข้า ม. 4",
          "ปูพื้นฐานและเพิ่มเกรดก่อนเพื่อสอบเข้ามหาวิทยาลัย",
          "TPAT",
          "TGAT",
          "A-LEVEL",
        ],
      },
    ],
  });

  const features = [
    {
      name: "สอนโดยทีมอาจารย์ผู้เชี่ยวชาญ",
      description:
        "เรียนตัวต่อตัวกับอาจารย์ผู้สอน ปรับแต่งกำหนดบทเรียนที่เหมาะสม เลือกเวลาเรียนเอง",
      icon: UserIcon,
    },
    {
      name: "จัดเวลาเรียนเองได้",
      description:
        "สามารถเรียนเวลาไหนก็ได้ น้องๆสามารถเลือกเวลาเรียนเองได้ ตามความเหมาะสมกับไลพ์สไตล์ตัวเอง",
      icon: ClockIcon,
    },
    {
      name: "เรียนคลาสส่วนตัว",
      description:
        "เรียนตัวต่อตัวกับอาจารย์ผู้สอน ปรับแต่งกำหนดบทเรียนที่เหมาะสม เลือกเวลาเรียนเอง",
      icon: UsersIcon,
    },
    {
      name: "เรียนออนไลน์ได้ทุกที่",
      description:
        "เรียนที่ไหนก็ได้ผ่าน application สะดวกสบาย ยืดหยุ่นเวลาได้มากขึ้น",
      icon: WindowIcon,
    },
  ];

  const tutor = [
    {
      name: "ดร. วรเดช พูนคำ",
      nickname: "ครูเติม",
      subject: "ฟิสิกส์และเคมี",
      imageUrl: "./img/kruterm.png",
      modalImg: "./img/kruterm_info.jpg",
    },
    {
      name: "ครู วิธิวัสส์ ปราณสิริจิรภาส",
      nickname: "ครูบิ๊ก",
      subject: "ภาษาอังกฤษ",
      imageUrl: "./img/krubig.png",
      modalImg: "./img/krubig_info.jpg",
    },
    {
      name: "ครู ศรัญย์ อินทะผิว",
      nickname: "ครูพี",
      subject: "คณิตศาสตร์",
      imageUrl: "./img/krupee.png",
      modalImg: "./img/krupee_info.jpg",
    },

    {
      name: "ดร. กิตต์ ปัญญารัตน์",
      nickname: "ครูกิตต์",
      subject: "เคมี",
      imageUrl: "./img/krukit.png",
      modalImg: "./img/krukit_info.jpg",
    },
    {
      name: "ดร. สาริทธิ์ จารุชัยบวร",
      nickname: "ครูมีน",
      subject: "ชีวะ",
      imageUrl: "./img/krumean.png",
      modalImg: "./img/krumean_info.jpg",
    },
    {
      name: "ดร. วีระวัฒน์ คลอวุฒิมันตร์",
      nickname: "ครูวี",
      subject: "คณิตศาสตร์",
      imageUrl: "./img/kruwee.png",
      modalImg: "./img/kruwee_info.jpg",
    },
  ];
  return (
    <motion.div
  
    >
      <div className="sm:bghome">
        <div className="sm:px-10 pt-14 sm:pt-3 md:pt-14 lg:pt-10 xl:pt-10 2xl:pt-0">
          {/* <h1 className="text-center text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl lg:text-8xl  xl:text-9xl ">
            กาลิเลโอ ติวเตอร์
          </h1>
          <h1 className="text-center text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl lg:text-8xl  xl:text-9xl ">
            สอนด้วยใจ{" "}
            <span className="text-purple-600">
              <br className="sm:hidd  en" />
              ไปให้ถึง A<sup>*</sup>
            </span>
          </h1> */}
          <motion.img
            // initial={{ opacity: 0, scale: 0.5 }}
            // animate={{ opacity: 1, scale: [0.5, 1.1, 1] }}
            // transition={{ delay: 1, duration: 0.5 }}
            src="./img/title.png"
            className="mx-auto hidden lg:block w-full"
          />
          <img
            src="./img/title-md.png"
            className="mx-auto hidden md:block lg:hidden"
          />
          <img src="./img/title-sm.png" className="mx-auto md:hidden" />

          <div className=" mt-7 flex justify-center gap-4 sm:gap-8">
            <a
              href="https://liff.line.me/1645278921-kWRPP32q/?accountId=galileo_tutor"
              target="_blank"
              className="rounded-xl bg-lime-500 px-4 py-3 text-lg font-bold text-white  duration-200 ease-in-out hover:scale-105 hover:bg-lime-600 sm:rounded-full sm:px-5 sm:py-5 sm:text-2xl md:px-12"
            >
              สมัครเรียนเลย !
            </a>

            <Link
              to="/course"
              className="rounded-xl bg-white px-4 py-3 text-lg font-bold duration-200  ease-in-out hover:bg-gray-200 sm:rounded-full sm:px-5 sm:py-5 sm:text-2xl md:px-12"
            >
              รายละเอียด
            </Link>
          </div>
        </div>
        <div className="mt-14">
          <OwlCarousel
            className=" owl-theme alltutor container mx-auto overflow-hidden "
            margin={10}
            items={1}
            stagePadding={10}
            autoplayHoverPause
            navText={[
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
            ]}
            nav
            // responsiveClass
            // responsive={{
            //   640:{

            //   }
            // }}
          >
            <img
              src="./img/banner1.jpg"
              className="rounded-3xl lg:rounded-[50px]"
              alt=""
            />
            <img
              src="./img/banner2.jpg"
              className="rounded-3xl lg:rounded-[50px]"
              alt=""
            />
            <img
              src="./img/banner3.jpg"
              className="rounded-3xl lg:rounded-[50px]"
              alt=""
            />
          </OwlCarousel>
        </div>
      </div>
      {/* Introduce */}

      <div
        className="mt-[-130px] bg-slate-100 pt-36 pb-32 sm:mt-[-400px] sm:pt-[450px]"
        id="intro"
      >
        <div className="mx-auto mt-7 grid max-w-screen-2xl gap-5 px-6 sm:grid-cols-2 sm:gap-10 md:grid-cols-2 lg:grid-cols-4  lg:gap-5 lg:px-8 xl:gap-10 ">
          {features.map((feature) => (
            <div key={feature.name} className="rounded-3xl bg-white  p-10">
              <dt className="text-base font-semibold leading-7 text-gray-900">
                <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full bg-purple-600">
                  <feature.icon
                    className="h-14 w-14 text-white"
                    aria-hidden="true"
                  />
                </div>
                <h3 className="mt-10 text-center text-2xl text-gray-900">
                  {feature.name}
                </h3>
              </dt>
            </div>
          ))}
        </div>
        <div className="mx-auto mt-52  grid max-w-screen-2xl gap-10 px-6 lg:px-8 xl:grid-cols-2 xl:gap-14 2xl:gap-24">
          <div>
            <h1 className="max-w-none text-[40px] font-extrabold leading-tight text-gray-800 sm:text-7xl md:max-w-2xl lg:max-w-2xl xl:max-w-none">
              กาลิเลโอติวเตอร์ สถาบันสอนพิเศษที่เน้น
              <span className="text-purple-500">การสอนส่วนตัว</span>
            </h1>
          </div>
          <div>
            <p className="text-2xl leading-tight text-gray-500 sm:text-3xl lg:max-w-3xl xl:max-w-none">
              หลักการของทีมงานเราเชื่อมั่นว่าการเรียนส่วนตัวจะทำให้ครูถ่ายทอดความรู้ที่มีประสิทธิภาพให้กับนักเรียนและสามารถทำให้นักเรียนโฟกัสในสิ่งต้องเรียนได้มากที่สุด
            </p>
            <Link to="/about-us">
              <p className="mt-10 inline-block border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:p-5 ">
                ทำความรู้จักกับพวกเรา &nbsp;
                <HiArrowUpRight className="inline" />
              </p>
            </Link>
          </div>
        </div>

        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <video
            src="./video/intro1.mp4"
            className=" mt-16 w-full rounded-lg sm:rounded-3xl "
            autoPlay
            muted
          ></video>
        </div>
      </div>

      {/* Courses */}

      <div className="overflow-hidden bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className="my-5 mx-auto  max-w-max rounded-full px-5 py-1 text-2xl font-extrabold  text-purple-500">
              Our Courses
            </h2>
            <p className="mt-2 text-center text-6xl font-extrabold  tracking-tight text-gray-800 sm:text-7xl xl:text-8xl ">
              คอร์สเรียนของพวกเรา
            </p>
          </div>
          <Tab.Group>
            <div className="mx-auto w-full max-w-2xl py-8 sm:px-0">
              <Tab.List className="flex flex-row  space-x-1 rounded-xl bg-slate-100 p-1">
                {Object.keys(courses).map((category) => (
                  <Tab
                    key={category}
                    className={({ selected }) =>
                      classNames(
                        "w-full rounded-xl py-2.5  text-sm  leading-5 text-gray-800",
                        selected
                          ? "bg-white shadow-md focus:outline-none"
                          : "text-gray-400"
                      )
                    }
                  >
                    {category}
                  </Tab>
                ))}
              </Tab.List>
            </div>

            <Tab.Panels className="mt-2">
              {Object.values(courses).map((course) => (
                <Tab.Panel className={classNames("rounded-xl bg-white sm:p-3")}>
                  {course.map((item) => (
                    <div className="grid gap-8 lg:grid-cols-2">
                      {item.name === "หลักสูตรไทย" ? (
                        <div className="col-span-2">
                          <div className="rounded-3xl bg-slate-100 p-5 sm:p-10 ">
                            <p className="my-6 text-4xl font-extrabold text-gray-800 sm:text-5xl 2xl:text-6xl">
                              คอร์สเรียนของ{" "}
                              <span className="text-purple-500">
                                {item.name}
                              </span>
                            </p>

                            <div className="overflow-hidden rounded-xl bg-white shadow sm:rounded-3xl">
                              <dl>
                                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                  {/*  */}
                                  <dt className="hidden text-2xl font-bold  text-gray-900 sm:inline">
                                    ระดับชั้นเรียน
                                  </dt>
                                  <dd className="mt-1 hidden text-2xl font-bold  text-gray-900 sm:col-span-2 sm:mt-0 sm:inline">
                                    คอร์สเรียน
                                  </dd>
                                  {/* sm */}
                                  <dt className=" text-2xl font-bold  text-gray-900 sm:hidden">
                                    คอร์สเรียนตามระดับชั้น
                                  </dt>
                                </div>
                                {item.level.map((level, idx) => (
                                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-0 sm:px-6">
                                    <dt className="text-2xl font-bold text-gray-800">
                                      {level}
                                    </dt>
                                    <dd className="mt-1 text-2xl text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item.course[idx]}
                                      <div>
                                        {item.subjects[idx].map(
                                          (subject, id) => (
                                            <div
                                              className={`mx-1 my-1 inline-block rounded-lg bg-${subject} cursor-pointer p-2 text-xl font-extrabold text-white duration-100 ease-in-out hover:scale-105`}
                                              onClick={() => {
                                                setSelectedItem(subject);
                                                setType("subject");
                                                setOpenDialog(true);
                                              }}
                                            >
                                              <GoPrimitiveDot className="inline" />{" "}
                                              {subject}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </dd>
                                  </div>
                                ))}
                              </dl>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="hidden rounded-3xl bg-slate-100 p-5 sm:p-10 lg:block ">
                            <p className="my-6 text-4xl font-extrabold text-gray-800 sm:text-5xl 2xl:text-6xl">
                              <span className="text-purple-500">
                                {item.name}{" "}
                              </span>
                              คืออะไร ?
                            </p>
                            <h1 className="my-6 hidden text-xl text-gray-500 sm:inline sm:text-2xl">
                              {item.description}
                            </h1>
                            <h1 className=" my-6 text-xl text-gray-500 sm:hidden sm:text-2xl">
                              {item.description.substring(0, 200)}...
                            </h1>

                            <a
                              href={item.href}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <p className="max-w-max border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:mt-10 sm:p-5 ">
                                ศึกษาเพิ่มเติม &nbsp;
                                <HiArrowUpRight className="inline" />
                              </p>
                            </a>
                          </div>
                          <div>
                            <div className="rounded-3xl bg-slate-100 p-5 sm:p-8">
                              <div className="overflow-hidden rounded-xl bg-white shadow sm:rounded-3xl">
                                <dl>
                                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-1 xl:grid-cols-3">
                                    {/*  */}
                                    <dt className="hidden text-2xl font-bold text-gray-900 sm:inline  lg:hidden xl:block">
                                      ระดับชั้นเรียน
                                    </dt>
                                    <dd className="mt-1 hidden text-2xl font-bold text-gray-900 sm:col-span-2  sm:mt-0 sm:inline lg:hidden xl:block">
                                      คอร์สเรียน
                                    </dd>
                                    {/* sm */}
                                    <dt className=" text-2xl font-bold text-gray-900 sm:hidden  lg:block xl:hidden">
                                      คอร์สเรียนตามระดับชั้น
                                    </dt>
                                  </div>
                                  {item.level.map((level, idx2) => (
                                    <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-0 sm:px-6 lg:grid-cols-1 lg:border-b xl:grid-cols-3">
                                      <dt className="text-2xl font-bold text-gray-800">
                                        {level}
                                      </dt>
                                      <dd className="mt-1 text-2xl text-gray-700 sm:col-span-2 sm:mt-0">
                                        {item.course[idx2]}
                                        <div>
                                          {item.subjects[idx2].map(
                                            (subject, id) => (
                                              <div
                                                className={`mx-1 my-1 inline-block rounded-lg bg-${subject} cursor-pointer p-2 text-xl font-extrabold text-white duration-100 ease-in-out hover:scale-105`}
                                                onClick={() => {
                                                  setSelectedItem(subject);
                                                  setType("subject");
                                                  setOpenDialog(true);
                                                }}
                                              >
                                                <GoPrimitiveDot className="inline" />{" "}
                                                {subject}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </dd>
                                    </div>
                                  ))}
                                </dl>
                              </div>
                            </div>
                          </div>
                          <div className=" rounded-3xl bg-slate-100 p-5 sm:p-10 lg:hidden ">
                            <p className="my-6 text-4xl font-extrabold text-gray-800 sm:text-5xl 2xl:text-6xl">
                              <span className="text-purple-500">
                                {item.name}{" "}
                              </span>
                              คืออะไร ?
                            </p>
                            <h1 className="my-6 hidden text-xl text-gray-500 sm:inline sm:text-2xl">
                              {item.description}
                            </h1>
                            <h1 className=" my-6 text-xl text-gray-500 sm:hidden sm:text-2xl">
                              {item.description.substring(0, 200)}...
                            </h1>

                            <a
                              href={item.href}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <p className="max-w-max border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:mt-10 sm:p-5 ">
                                ศึกษาเพิ่มเติม &nbsp;
                                <HiArrowUpRight className="inline" />
                              </p>
                            </a>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>

      {/* Tutors */}
      <div className=" py-24 sm:py-32 ">
        <div className="mx-auto grid max-w-screen-2xl px-6 lg:grid-cols-2 lg:gap-8  lg:px-8 xl:gap-0">
          <div className="hidden items-center lg:flex">
            <div>
              <h2 className="  my-5 max-w-max  rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500">
                All Tutors
              </h2>
              <p className="mt-2 max-w-2xl text-3xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-8xl lg:text-7xl xl:text-8xl">
                รู้จักกับพี่ๆ
                <span className="text-purple-500">ติวเตอร์ของเรา</span>
              </p>

              <p className="mt-4 max-w-lg text-3xl text-gray-500">
                แนะนำให้รู้จักกับประวัติของพี่ ๆ ติวเตอร์ของกาลิเลโอ ติวเตอร์
              </p>
              <Link to="/our-team">
                <p className="mt-10 inline-block border border-gray-800 bg-gray-800 p-5 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-white hover:text-gray-800 ">
                  อ่านเพิ่มเติม &nbsp;
                  <HiArrowUpRight className="inline" />
                </p>
              </Link>
            </div>
          </div>

          <OwlCarousel
            className="owl-theme alltutor overflow-hidden"
            items={1}
            nav
            navText={[
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
            ]}
            responsive={{
              768: {
                items: 2,
                margin: 10,
              },
              1024: {
                items: 1,
              },
            }}
          >
            {tutor.map((person) => (
              <div className="relative">
                <img src={person.imageUrl} alt="" />
                <div className="absolute bottom-0 max-w-xs rounded-xl  bg-white p-2 sm:p-5 xl:bottom-10 xl:left-14">
                  <p className="max-w-max rounded-full bg-purple-500 px-2 text-lg text-white">
                    {person.subject}
                  </p>

                  <h1 className="mt-3 text-2xl font-extrabold text-gray-800 lg:text-4xl">
                    {person.nickname}
                  </h1>
                  <p className="mb-3 text-xl text-gray-500">{person.name}</p>
                  <div className="hidden lg:inline-block ">
                    <button
                      className="mt-2 border border-black px-4 text-black duration-150  ease-in-out hover:bg-black hover:text-white"
                      onClick={() => {
                        setSelectedItem(person);
                        setType("tutor");
                        setOpenDialog(true);
                      }}
                    >
                      รู้จักกับคุณครู <HiArrowUpRight className="inline " />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </OwlCarousel>
          <div className="lg:hidden ">
            <h2 className="my-5 hidden  max-w-max rounded-full  bg-slate-100 px-5 py-1 text-2xl font-extrabold text-purple-500  sm:block">
              All Tutors
            </h2>
            <p className="mt-10 max-w-2xl text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:mt-2 sm:text-7xl lg:text-8xl">
              รู้จักกับพี่ๆ
              <span className="text-purple-500">ติวเตอร์</span>
            </p>
            <p className="mt-4 max-w-lg text-2xl text-gray-500 sm:text-3xl">
              แนะนำให้รู้จักกับประวัติของพี่ ๆ ติวเตอร์ของกาลิเลโอ ติวเตอร์
            </p>
            <Link to="/our-team">
              <p className="mt-10 inline-block border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:p-5 ">
                อ่านเพิ่มเติม &nbsp;
                <HiArrowUpRight className="inline" />
              </p>
            </Link>
          </div>
        </div>
      </div>

      {/* Success */}

      <div className="overflow-hidden bg-white py-24 sm:max-h-[1100px] sm:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" mx-auto rounded-full py-1 text-2xl font-extrabold  text-purple-500">
              Our Success
            </h2>
            <p className="mt-2 text-6xl   font-extrabold tracking-tight text-gray-800 sm:max-w-xl   sm:text-7xl lg:text-7xl xl:max-w-3xl xl:text-8xl">
              <span className="text-purple-500">ผลตอบรับ</span>หลังจากที่น้องๆ
              ได้เรียน
            </p>
            <Link to="/success">
              <p className="mt-10 inline-block border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:p-5">
                อ่านเพิ่มเติม &nbsp;
                <HiArrowUpRight className="inline" />
              </p>
            </Link>
          </div>
        </div>
        <div className=" success mx-auto  mt-16 sm:mt-20 lg:mt-10 lg:max-w-none ">
          <div className="hidden gap-x-5 px-8 sm:block sm:columns-2 lg:columns-3  xl:columns-4 2xl:columns-5">
            {review.map((student, idx) => (
              <div
                class="my-2 inline-block rounded-2xl border border-slate-100 bg-white p-10 text-left shadow-lg duration-200 ease-in-out hover:scale-105 hover:cursor-pointer"
                onClick={() => {
                  setSelectedItem(student);
                  setType("review");
                  setOpenDialog(true);
                }}
                key={idx}
              >
                <div className="mb-7 flex flex-row">
                  <img
                    src={`./img/student/${student.name}.jpg`}
                    className="h-16  w-16 rounded-full"
                  />
                  <div className="mx-5 items-center">
                    <h5 className="text-2xl font-medium">N' {student.name}</h5>
                    <p className="text-lg text-purple-500">{student.school}</p>
                  </div>
                </div>
                <p className="lg:text-lg xl:text-xl">{student.description}</p>
              </div>
            ))}
          </div>
          <div className="block overflow-hidden sm:hidden">
            <Marquee speed={3} delay={1} gradient={false} pauseOnHover={true}>
              {review.map((student, idx) => (
                <div
                  class="mx-2  inline-block max-h-72 max-w-md  overflow-hidden rounded-2xl bg-white p-10 text-left  shadow-md"
                  onClick={() => {
                    setSelectedItem(student);
                    setType("review");
                    setOpenDialog(true);
                  }}
                  key={idx}
                >
                  <div className="mb-7 flex flex-row">
                    <img
                      src={`./img/student/${student.imgUrl}`}
                      className="h-16  w-16 rounded-full"
                    />
                    <div className="mx-5 items-center">
                      <h5 className="text-2xl font-medium">
                        N' {student.name}
                      </h5>
                      <p className="text-lg text-purple-500">
                        {student.school}
                      </p>
                    </div>
                  </div>
                  <p className="lg:text-lg xl:text-xl">
                    {student.description.substring(0, 200)}...
                  </p>
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      </div>

      {/* Blog */}

      <div className="bg-slate-100 py-24 sm:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" mx-auto rounded-full py-1 text-2xl font-extrabold  text-purple-500">
              Blog & News
            </h2>
            <p className="mt-2 text-6xl font-extrabold   leading-tight tracking-tight  text-gray-800 sm:max-w-xl sm:text-7xl xl:max-w-3xl xl:text-8xl">
              <span className="text-purple-500">บทความและข่าวสาร</span>
              ที่น่าสนใจ
            </p>
            <Link to="/blogs">
              <p className="mt-10 inline-block border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:p-5">
                อ่านเพิ่มเติม &nbsp;
                <HiArrowUpRight className="inline" />
              </p>
            </Link>
          </div>

          <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 pt-10 sm:grid-cols-2  sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {blog
              .sort((a, b) => b.id - a.id)
              .map((post, idx) => (
                <article
                  key={idx}
                  className="mb-16 cursor-pointer  duration-200 ease-in-out hover:scale-105"
                  onClick={() => {
                    setSelectedItem(post);
                    setType("blog");
                    setOpenDialog(true);
                  }}
                >
                  <img
                    src={`./img/blog/${post.id}/${post.thumbnail}`}
                    className="mb-5 rounded-2xl"
                  />
                  <div className=" gap-x-4 text-xs">
                    <p className="text-gray-500">{post.date}</p>
                  </div>
                  <div className="group relative">
                    <h3 className="mt-3 text-3xl  font-semibold leading-tight text-gray-900 group-hover:text-gray-600">
                      {post.title}
                    </h3>
                    <p className=" mt-5  text-xl text-gray-600">
                      {post.description}
                    </p>
                  </div>
                  <div className="relative mt-8 flex items-center gap-x-4">
                    <img
                      src={`./img/${post.author.imageUrl}`}
                      alt=""
                      className="h-14 w-14 rounded-full bg-gray-50"
                    />
                    <div className="text-lg leading-6">
                      <p className="font-semibold text-gray-900">
                        <a href={post.author.href}>{post.author.name}</a>
                      </p>
                      <p className="text-gray-600">{post.author.role}</p>
                    </div>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </div>

      <Modal
        isOpen={openDialog}
        selectedItem={selectedItem}
        type={type}
        handleClose={() => {
          setOpenDialog(false);
          setSelectedItem({});
        }}
      />
      <CTA />

      <Footer />
    </motion.div>
  );
}
